import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {useNavigate} from "react-router-dom";
import {LoggedInView} from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import {Link, useParams} from "react-router-dom";
import {createExtension, resetCreateExtensionStatus} from "../../store/reducers/ExtensionsSlice";
import {RequestStatus} from "../../utils/Enums";
import {getUsers} from "../../store/reducers/UsersSlice";
import ElogSelect, {Option} from "../common/form/ElogSelect";
import {FormikProvider, useFormik, Form} from "formik";
import {createSMSSender} from "../../store/reducers/SMSSendersSlice";

interface NewExtensionScreenProps {
}

export interface NewExtensionFormProps {
    user: number;
    expires_at: string;
}

export const NewExtensionScreen: React.FC<NewExtensionScreenProps> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const usersState = useAppSelector((state) => state.users);
    const extensionsState = useAppSelector((state) => state.extensions);
    const requestStatus: RequestStatus = extensionsState.createExtensionStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Pikendused", url: "/extensions"},
        {text: "Pikenduse lisamine", url: "/extensions/new"},
    ];

    useEffect(() => {
        if (requestStatus === RequestStatus.Success) {
            dispatch(resetCreateExtensionStatus());
            navigate(breadcrumbLinks[0].url);
        }
    }, [requestStatus]);

    useEffect(() => {
        dispatch(getUsers());
    }, []);

    const userOptions: Option[] = usersState.users
        .filter((user) => user.logistician === 1 || user.is_checker === 1)
        .map((user) => ({
            value: user.id.toString(),
            label: `${user.firstname} ${user.lastname}`,
        }));

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
            user: userOptions[0]?.value
        },
        onSubmit: (values: any) => {
            dispatch(createExtension(values));
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Failed &&
            extensionsState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {extensionsState.errors.map(
                            (error, index) => (
                                <span key={index}>
                                        {error}
                                    <br/>
                                    </span>
                            )
                        )}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2>
                            <span>Pikenduse andmed</span>
                        </h2>
                        <table className="form">
                            <tbody>
                            <ElogSelect label="Logistik" name="user" options={userOptions} mandatory={true}/>
                            <ElogInput label="Tunde pikendust" name="expires_at" mandatory={true}/>
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                                  <span>
                                    <strong>Salvesta</strong>
                                  </span>
                            </button>
                            <Link to="/extensions">Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    );
};